import {useState, useEffect} from 'react'
import {useSearchParams, Link} from 'react-router-dom'
import {getAuth} from '../../modules/auth/core/AuthHelpers'

const API_URL = process.env.REACT_APP_API_URL

// Public page opened from the Telegram bot login link:
//   /telegram-connect?state=<one-time-state>
// If the user already has a console session, they just tap "Confirm" and their
// account is linked to the bot. If not, they log in first, then reopen the link.
const TelegramConnect = () => {
  const [searchParams] = useSearchParams()
  const state = searchParams.get('state') || ''
  const token = getAuth()?.api_token
  const [status, setStatus] = useState<'idle' | 'loading' | 'done' | 'error'>('idle')
  const [error, setError] = useState('')

  // This page renders OUTSIDE the <App> wrapper, so the HTML boot splash
  // (#splash-screen in index.html) is never auto-hidden — do it here.
  useEffect(() => {
    const splash = document.getElementById('splash-screen')
    if (splash) splash.style.display = 'none'
  }, [])

  const confirm = async () => {
    setStatus('loading')
    setError('')
    try {
      const res = await fetch(`${API_URL}/tg/confirm`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({state, api_token: token}),
      })
      const data = await res.json().catch(() => ({}))
      if (!res.ok || !data.ok) throw new Error(data.error || 'החיבור נכשל')
      setStatus('done')
    } catch (e: any) {
      setError(e.message || 'החיבור נכשל')
      setStatus('error')
    }
  }

  const wrap: React.CSSProperties = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    background: '#0f172a',
  }
  const card: React.CSSProperties = {
    width: '100%',
    maxWidth: 400,
    background: '#1e293b',
    color: '#e2e8f0',
    borderRadius: 16,
    padding: '32px 28px',
    textAlign: 'center',
    boxShadow: '0 10px 40px rgba(0,0,0,.35)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  }
  const btn: React.CSSProperties = {
    width: '100%',
    marginTop: 20,
    padding: '13px',
    border: 0,
    borderRadius: 10,
    background: '#6366f1',
    color: '#fff',
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
  }

  let body
  if (!state) {
    body = <p>הקישור לא תקין או שפג תוקפו. שלחו /login לבוט שוב.</p>
  } else if (!token) {
    body = (
      <>
        <p style={{color: '#94a3b8'}}>
          התחברו לחשבון, ואז פתחו שוב את הקישור מהבוט כדי לסיים את החיבור.
        </p>
        <Link to='/auth/login' style={{...btn, display: 'block', textDecoration: 'none'}}>
          התחברות
        </Link>
      </>
    )
  } else if (status === 'done') {
    body = (
      <>
        <div style={{fontSize: 42, marginBottom: 8}}>✅</div>
        <h2 style={{margin: '0 0 8px'}}>החשבון חובר!</h2>
        <p style={{color: '#94a3b8'}}>חזרו לטלגרם ושלחו /campaigns כדי להתחיל.</p>
      </>
    )
  } else {
    body = (
      <>
        <p style={{color: '#94a3b8'}}>
          חברו את החשבון לבוט הטלגרם כדי לנהל את הקמפיינים והפוסטים ישירות מהצ׳אט.
        </p>
        <button style={btn} onClick={confirm} disabled={status === 'loading'}>
          {status === 'loading' ? 'מחבר…' : 'אישור וחיבור'}
        </button>
        {status === 'error' && (
          <p style={{color: '#fca5a5', marginTop: 12, fontSize: 13}}>{error}</p>
        )}
      </>
    )
  }

  return (
    <div style={wrap} dir='rtl'>
      <div style={card}>
        <div style={{fontSize: 13, letterSpacing: 1, color: '#64748b', marginBottom: 12}}>
          fb-zipper · טלגרם
        </div>
        {body}
      </div>
    </div>
  )
}

export default TelegramConnect
